/**
 * @fileoverview Modal displaying QR Code with PremiumQR for fan direct access in Adivina Adivinador (Riddle).
 * 
 * @module components/Admin/Games/Riddle/RiddleQrModal
 */

import React, { useEffect } from 'react';
import { PremiumQR } from './../../../Commons/PremiumQR';

/**
 * Riddle QR Code Modal Component.
 * 
 * @function RiddleQrModal
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is open.
 * @param {Function} props.onClose - Close handler.
 * @returns {React.ReactElement|null}
 */
export const RiddleQrModal = ({ isOpen, onClose }) => {
    // Determine fan URL pointing to root /
    const fanUrl = typeof window !== 'undefined'
        ? `${window.location.origin}/`
        : 'https://adsl.fivedigitalminds.com/';

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <>
            <div className="cModal__Background" onClick={onClose}></div>
            <div className="cModal__Container" style={{ maxWidth: '450px' }}>
                <div className="cModal__Container__Content p-4 text-center">
                    <button
                        type="button"
                        className="Btn__Adsl--RedOutline cModal__Container__Content__CloseButton"
                        onClick={onClose}
                    >
                        X
                    </button>

                    <div className="py-2">
                        <PremiumQR
                            url={fanUrl}
                            title="¡ESCANEA Y ADIVINA!"
                        />
                    </div>

                    <div className="mt-3">
                        <button
                            type="button"
                            className="btn btn-secondary px-4 w-100"
                            onClick={onClose}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
